import { z } from "zod"

const text = z.string().max(512)
const id = z.string().min(1).max(256)
const amount = z.number().finite().nonnegative().nullable()
export const searchInputSchema = z.object({
  query: z
    .string()
    .max(160)
    .transform((value) =>
      value
        .replace(/[\p{Cc}\p{Cf}]/gu, "")
        .trim()
        .replace(/\s+/g, " ")
    ),
  mode: z.enum(["autocomplete", "page"]).default("page"),
  page: z.coerce.number().int().min(1).max(100).default(1),
  sortBy: z
    .enum(["relevance", "price_asc", "price_desc", "title"])
    .default("relevance"),
  inStockOnly: z.boolean().default(false),
})
export type ProductSearchInput = z.infer<typeof searchInputSchema>

// The existing backend indexes variants and resolves the tenant from the key.
export const meiliProductResultSchema = z.object({
  hits: z.array(z.object({ id, product_id: id, variant_id: id })).max(24),
  total: z.number().int().nonnegative(),
  ms: z.number().finite().nonnegative(),
  query: z.string().max(160),
})
export const searchItemSchema = z.object({
  id,
  productId: id,
  handle: z.string().min(1).max(256),
  title: text,
  variantTitle: text.nullable(),
  thumbnail: z.string().max(2048).nullable(),
  price: amount,
  inStock: z.boolean(),
  stockUnverified: z.boolean().default(false),
  installation: z.boolean(),
})
export const productSearchResponseSchema = z.object({
  items: z.array(searchItemSchema).max(24),
  total: z.number().int().nonnegative(),
  page: z.number().int().min(1).max(100),
  pageSize: z.number().int().min(1).max(24),
  query: z.string().max(160),
})
export type ProductSearchItem = z.infer<typeof searchItemSchema>
export type ProductSearchResponse = z.infer<typeof productSearchResponseSchema>
